<template>
	<c-dialog ref="dialog" mode="slide" width="650" mask-close>
		<template v-if="progressList">
			<ul v-if="progressList.length">
				<li v-for="(progress, i) in progressList" :key="i">
					<div class="head flex-center-cross">
						<c-state dict="outSourcingOrderProcessName" tag :value="progress.progress_type"></c-state>
						<span class="date">{{progress.create_date}}</span>
					</div>
					<div class="content">
						<c-button v-if="progress.create_user_type==2 && (auth('b_outsourcing_order_send') || auth('b_outsourcing_order_receive'))" class="edit" color="main" @click="receiveOrSendOrder(progress.progress_type,progress)">编辑</c-button>
						<div class="item flex">
							<label>填报人：</label>
							<div class="flex-grow">{{progress.create_user_realname}}</div>
						</div>
						<div class="item flex">
							<label>数量：</label>
							<div class="flex-grow">{{progress.product_count}}</div>
						</div>
						<div class="item flex">
							<label>备注：</label>
							<div class="flex-grow">{{progress.remark || '-'}}</div>
						</div>
						<div class="item flex">
							<label>附件：</label>
							<div class="flex-grow">
								<div v-if="progress.attachment_file_url" class="file flex-wrap">
									<c-file v-for="(image, j) in progress.attachment_file_url.split(',')" :key="j" class="img" :src="image" media></c-file>
								</div>
								<span v-else>-</span>
							</div>
						</div>
					</div>
				</li>
			</ul>
			<c-empty v-else></c-empty>
		</template>

		<template #button>
			<c-button size="dialog" color="main" v-if="auth('b_outsourcing_order_send')" v-lock="lock('b_outsourcing_order_send')" @click="receiveOrSendOrder(1,null)">发货</c-button>
			<c-button size="dialog" color="main" v-if="auth('b_outsourcing_order_receive')" v-lock="lock('b_outsourcing_order_receive')" @click="receiveOrSendOrder(2,null)">收货</c-button>
		</template>
		<!--委外单收货、发货、增加动态弹窗-->
		<out-sourcing-process-edit ref="outSourcingProcessEdit" @resolve="loadProgressList()"></out-sourcing-process-edit>
	</c-dialog>
</template>

<script>
	import outSourcingProcessEdit from "@/pages/supply/out_sourcing_order_process_edit.vue";

	export default {
		components: {
			outSourcingProcessEdit
		},

		data() {
			return {
				taskInfo: null,
				progressList: null
			}
		},

		methods: {
			/**
			 * 打开发货 、收货框
			 * @param data      外协单信息
			 * @param type      类型 1：发货  2：收货
			 */
			open(data) {
				this.taskInfo = data;
				this.progressList = null;
				this.loadProgressList();
			},
			/**
			 * 加载外协单动态数据列表
			 */
			loadProgressList(){
				this.out_sourcing_order_id = this.taskInfo.id;
				this.request({
					url:'/out/sourcing/order/progress/list',
					data: {
						id: this.out_sourcing_order_id
					},
					loading: true,
					success: data => {
						this.progressList = data;
						this.$refs.dialog.open({
							title: '任务动态 | '+this.taskInfo.work_code+' | '+this.taskInfo.process_name
						});
					}
				});
			},
			/**
			 * 发货 、收货
			 * @param type            类型 1：发货  2：收货
			 * @param processInfo     需要编辑的动态记录信息
			 */
			receiveOrSendOrder(type,processInfo){
				this.taskInfo.processInfo = processInfo;
				this.$refs.outSourcingProcessEdit.open(this.taskInfo,type);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	ul {
		position: relative;
		padding: 20px 50px;

		&:before {
			content: '';
			position: absolute;
			left: 32px;
			top: 20px;
			bottom: 0;
			width: 1px;
			background: #eee;
		}

		li {
			position: relative;

			&:nth-child(n+2) {
				margin-top: 12px;
			}

			&:before {
				content: '';
				position: absolute;
				left: -23px;
				top: 15px;
				box-sizing: border-box;
				width: 12px;
				height: 12px;
				border: 2px solid #ddd;
				border-radius: 100%;
				background: #fff;

				^[-1]:nth-child(1)^[-1..-1] {
					border-color: var(--color-main);
				}
			}

			.head {
				gap: 10px;
				height: 40px;

				.date {
					font-size: 12px;
					color: #999;
				}
			}

			.content {
				position: relative;
				border: 1px solid #eee;
				padding: 10px 14px;

				.edit {
					position: absolute;
					right: -1px;
					top: -1px;
				}

				.item {
					padding: 4px 0;
					line-height: 18px;
					font-size: 13px;

					label {
						color: #666;
					}

					.file {
						gap: 6px;

						>>> .c-file-media {
							width: 40px;
							height: 40px;
						}
					}
				}
			}
		}
	}
</style>